export var DrugLegendStatus;
(function (DrugLegendStatus) {
    DrugLegendStatus["RX"] = "Rx";
    DrugLegendStatus["OTC"] = "OTC";
    DrugLegendStatus["C3"] = "C3";
    DrugLegendStatus["C4"] = "C4";
    DrugLegendStatus["C5"] = "C5";
})(DrugLegendStatus || (DrugLegendStatus = {}));
;
export var DeaClass;
(function (DeaClass) {
    DeaClass["NON_CONTROL"] = "";
    DeaClass["SCHEDULE_1"] = "1";
    DeaClass["SCHEDULE_2"] = "2";
    DeaClass["SCHEDULE_3"] = "3";
    DeaClass["SCHEDULE_4"] = "4";
    DeaClass["SCHEDULE_5"] = "5";
})(DeaClass || (DeaClass = {}));
;
;
